import React, { useEffect, useState } from 'react';
import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLegalDocumentsRequests } from '../../../api/legal';
import { LegalDocument, LegalDocumentKind } from '../../../types/legal';
import styles from './legalLinks.module.css';

export const DOCUMENT_LABELS: Record<LegalDocumentKind, string> = {
  TOS: 'Terms of service',
  PRP: 'Privacy policy',
  DPA: 'Data processing agreement',
  SLA: 'Service level agreement',
  SUB: 'Subprocessors list',
  SEC: 'Security overview',
  UNO: 'User information notice',
  PUN: 'Portal user information notice',
};

// The order documents are listed in, everywhere they are listed.
const DISPLAY_ORDER: LegalDocumentKind[] = [
  'TOS',
  'SLA',
  'DPA',
  'PRP',
  'SUB',
  'SEC',
  'UNO',
  'PUN',
];

export const sortDocuments = (documents: LegalDocument[]): LegalDocument[] =>
  [...documents].sort(
    (a, b) => DISPLAY_ORDER.indexOf(a.kind) - DISPLAY_ORDER.indexOf(b.kind)
  );

interface LegalLinksProps {
  // Restrict the list, e.g. to the documents shown next to a signup form.
  kinds?: LegalDocumentKind[];
}

export const LegalLinks = ({ kinds }: LegalLinksProps) => {
  const { t } = useTranslation();
  const { query } = useLegalDocumentsRequests();
  const [documents, setDocuments] = useState<LegalDocument[]>([]);

  useEffect(() => {
    query().then((data) => setDocuments(sortDocuments(data)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const visible = kinds
    ? documents.filter((document) => kinds.includes(document.kind))
    : documents;

  if (!visible.length) {
    return null;
  }

  return (
    <Box className={styles.linksBox}>
      {visible.map((document) => (
        <Link
          key={document.id}
          href={document.url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          variant="body2"
        >
          {t(DOCUMENT_LABELS[document.kind])}
        </Link>
      ))}
    </Box>
  );
};
